import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {catchError, map, tap} from "rxjs/operators";
import {SearchResult} from "../interfaces/SearchResult";
import {JWTToken} from "../interfaces/JWTToken";
import {throwError} from "rxjs";
import {ErrorHandlerService} from "../classes/APIErrorHandler";
import {SocialMedia} from "../interfaces/SocialMedia";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class APIClientService {

  baseUrl = environment.apiUrl;
  apiVersion = "v1";

  private jwtToken: JWTToken | null
  private refreshTokenTimer: ReturnType<typeof setTimeout>;

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService) {
    this.getToken()
    this.baseUrl = environment.apiUrl
  }

  // getData() {
  //   return this.http.get<any>('https://jsonplaceholder.typicode.com/users')
  //     .pipe(
  //       map((response:[]) => response.map(item => item['name']))
  //       // map((response:any) => {
  //       //   response.map(item => item['name'])
  //       // })
  //     )
  // }

  // searchFor(textToSearchFor: string)
  // {
  //   return this.http.get<SearchResult>(this.baseUrl + '/' + this.apiVersion + '/search/' + textToSearchFor)
  //     .pipe(
  //       map((response:SearchResult) => response.merchants.map(item => item['name']))
  //       // map((response:any) => {
  //       //   response.map(item => item['name'])
  //       // })
  //     )
  // }

  searchFor(textToSearchFor: string) {
    return this.http.get<SearchResult>(this.baseUrl + '/' + this.apiVersion + '/search/' + textToSearchFor)
  }

  logout() {
    return this.http.post<any>(this.baseUrl + '/' + this.apiVersion + '/account/logout', "")
      .pipe(
        map(() => {
          this.clearJWTToken()
        })
      )
  }

  verifyMerchantPhone(token: string) {
    return this.http.post(this.baseUrl + "/" + this.apiVersion + "/merchant/" + this.jwtToken?.user.merchantId + "/phone/verify/" + token, {})
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.log(error.error)
          const processedError = this.errorHandler.handleApiError(error);
          // Rethrow the error for the component to handle
          return throwError(() => processedError)
          // return throwError(processedError);
        }),
        map(() => {
          console.log("Returning success")
        })
      )
  }

  refreshToken() {
    return this.http.post<JWTToken>(this.baseUrl + '/' + this.apiVersion + '/account/refreshToken', "")
      .pipe(
        // catchError((err: HttpErrorResponse) => {
        //   console.log('Caught in CatchError. Returning 0')
        //   // return Observable<JWTToken>;     //return from(['A','B','C'])
        //   // Return an observable with a user-facing error message.
        //   return throwError(() => new Error('Something bad happened; please try again later.'));
        // }),
        catchError((error: HttpErrorResponse) => {
          console.log("catch Error method started")
          if (error.status === 401) {
            console.log("Unauthorized response.")
          } else if (error.status === 422) {
            console.log("Validation error..")
          }
          // Return an ObservableInput
          // return Observable;
          // Return an observable with a user-facing error message.
          return throwError(() => new Error('Something bad happened; please try again later.'));
        }),
        map((response: JWTToken) => {
            this.saveJWTToken(response)
            return response
          }
        )
      )
  }

  saveJWTToken(jwtToken: JWTToken) {
    console.log("Saving token.. First clear existing JWT token if it exists.")
    this.clearJWTToken()

    this.jwtToken = jwtToken

    localStorage.setItem("token", this.jwtToken.accessToken)
    localStorage.setItem("tokenExpiry", Math.floor(new Date().getTime() / 1000) + this.jwtToken.accessToken)
    localStorage.setItem("tokenType", this.jwtToken.tokenType)
    if (this.jwtToken != null && this.jwtToken.user != null)
      localStorage.setItem("user", JSON.stringify(this.jwtToken.user));
    else
      localStorage.removeItem("user")


    clearTimeout(this.refreshTokenTimer) // Not sure if this is needed.
    let timerTickIn = (this.jwtToken.expiresIn * 0.9)
    console.log("refreshing token in " + timerTickIn)
    this.refreshTokenTimer = setTimeout(() => {
      console.log("refreshing token now")
      this.refreshToken().subscribe()
    }, timerTickIn * 1000);
  }

  private clearJWTToken() {
    console.log("clearing token now")
    clearTimeout(this.refreshTokenTimer)
    this.jwtToken = null
    localStorage.clear() // TEST
    // TODO remove mobile number from local storage
  }

  private isLoggedIn() {
    if (this.jwtToken) {
      if (!localStorage.getItem("token")) {
        localStorage.setItem("token", this.jwtToken.accessToken)
      }

      if (!localStorage.getItem("tokenExpiry")) {
        localStorage.setItem("tokenExpiry", Math.floor(new Date().getTime() / 1000) + this.jwtToken.accessToken)

      }

      if (!localStorage.getItem("tokenType")) {
        localStorage.setItem("tokenType", this.jwtToken.tokenType)
      }

      if (!localStorage.getItem("user")) {
        if (this.jwtToken.user != null)
          localStorage.setItem("user", JSON.stringify(this.jwtToken.user));
        else
          localStorage.removeItem("user")
      }
      return true
    }
    return false
  }

  private getToken() {
    if (this.jwtToken == undefined) {
      if (localStorage.getItem("token") && localStorage.getItem("tokenType") && localStorage.getItem("tokenExpiry") && localStorage.getItem("user")) {
        this.jwtToken = {
          accessToken: localStorage.getItem("token")!,
          tokenType: localStorage.getItem("tokenType")!,
          expiresIn: parseInt(localStorage.getItem("tokenExpiry")!),
          user: JSON.parse(localStorage.getItem("user")!),
          customer: localStorage.getItem("customer") !== null ? JSON.parse(localStorage.getItem("customer")!) : null
        }
      }


      // localStorage.setItem("tokenExpiry", Math.floor(new Date().getTime() / 1000)  + this.jwtToken.accessToken)
      // localStorage.setItem("tokenType", this.jwtToken.tokenType)
      // if(this.jwtToken != null && this.jwtToken.user != null)
      //   localStorage.setItem("user", JSON.stringify(this.jwtToken.user));
      // else
      //   localStorage.removeItem("user")


    }
  }
}
